import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Input } from 'reactstrap';
import remove from '../Res/Icon/remove.png';
import './MultiInput.css';
class MultiInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentValue: '',
      invalidValue: false,
    };
  }

  onInputChange = ev => {
    const { value: currentValue } = ev.target;
    this.setState({
      currentValue,
    });
  };

  onValuesChange = values => {
    const { onChange } = this.props;
    onChange(values);
  };

  addValue = () => {
    const { currentValue } = this.state;
    const { validator, inputData } = this.props;
    if (!validator(currentValue)) {
      this.setState({
        invalidValue: true,
      });
      return;
    }
    if (inputData.find(val => val === currentValue)) {
      this.setState({
        invalidValue: true,
      });
      return;
    }
    const newValues = [...inputData, currentValue];
    this.setState({
      currentValue: '',
      invalidValue: false,
    });
    this.onValuesChange(newValues);
  };

  onKeyPress = ev => {
    const keyCode = typeof ev.which === 'number' ? ev.which : ev.keyCode;
    // Enter key
    if (keyCode === 13) {
      const { currentValue } = this.state;
      if (!currentValue) {
        return;
      }
      this.addValue();
      return;
    }
    // Escape key
    if (keyCode === 27) {
      this.setState({
        currentValue: '',
        invalidValue: false,
      });
    }
  };

  removeValue = index => {
    const { inputData } = this.props;
    const valuesWIthRemoved = inputData.filter((val, ind) => ind !== index);
    this.onValuesChange(valuesWIthRemoved);
  };

  renderEmails = () => {
    const { inputData, disabledAdmin } = this.props;
    return inputData.map((value, ind) => {
      return (
        <div className="multi-input-item" key={value}>
          <span className="item">{value}</span>
          <img
            className="remove-icon"
            src={remove}
            onClick={() => (!disabledAdmin ? this.removeValue(ind) : null)}
            alt="remove"
          />
          {/* <FontAwesomeIcon
            icon="window-close"
            size="sm"
            title="Remove Notification Email"
            color="#999"
            mask={['far', 'circle']}
            onClick={() => !disabledAdmin ? this.removeValue(ind) : null}
          /> */}
        </div>
      );
    });
  };

  render() {
    const { currentValue, invalidValue } = this.state;
    const { disabledAdmin, placeholder } = this.props;
    return (
      <div className="multi-input">
        <div className="input-container" style={{border: `${currentValue?.length && invalidValue ? '1px solid red' : ''}`}}>
          <Input
            className="multi-input-control"
            autoComplete="off"
            placeholder={placeholder || ''}
            invalid={invalidValue}
            value={currentValue}
            onChange={this.onInputChange}
            onKeyUp={this.onKeyPress}
            disabled={disabledAdmin ? disabledAdmin : false}
          />
          <span className="multi-input-control-indicator" style={{height: '34px'}}>
            {currentValue.length ? (
              <Button
                style={{ background: '#3b5aa9', border: 'none', color: '#FFFFFF' }}
                onClick={this.addValue}
              >
                <FontAwesomeIcon
                  icon="plus"
                  size="sm"
                  color="#FFFFFF"
                  style={{ marginRight: '1rem' }}
                />
                Add
              </Button>
            ) : (
              ''
            )}
          </span>
        </div>
        <div className="multi-input-info">
          Type a value and press <strong>enter</strong> to add to the list
        </div>
        <div className="email-list">{this.renderEmails()}</div>
      </div>
    );
  }
}

MultiInput.propTypes = {
  validator: PropTypes.func,
  inputData: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
};

MultiInput.defaultProps = {
  validator: () => true,
  onChange: () => {},
  inputData: [],
};

export default MultiInput;
